import AdvisersApi from '../../../../core/api/AdvisersApi'
const api = new AdvisersApi()

export const events = {
  setting: {
    ifaCode: 'ADVISER_ADD_SET_IFA_CODE',
    firstName: 'ADVISER_ADD_SET_FIRST_NAME',
    middleName: 'ADVISER_ADD_SET_MIDDLE_NAME',
    lastName: 'ADVISER_ADD_SET_LAST_NAME'
  },
  submit: {
    adviser: 'ADVISER_ADD_SUBMIT'
  },
  submitting: {
    adviser: 'ADVISER_ADD_SUBMITTING'
  },
  submitted: {
    adviser: 'ADVISER_ADD_SUBMITTED'
  }
}

export const actions = {
  setting: {
    // ✅ ALWAYS STRING ONLY
    ifaCode: (value) => ({
      type: events.setting.ifaCode,
      payload: value
    }),

    firstName: (value) => ({
      type: events.setting.firstName,
      payload: value
    }),

    middleName: (value) => ({
      type: events.setting.middleName,
      payload: value
    }),

    lastName: (value) => ({
      type: events.setting.lastName,
      payload: value
    })
  },

  submit: {
    adviser: (adviser) => {
      const request = api.addAdviser(adviser)

      return (dispatch) => {
        dispatch({ type: events.submitting.adviser })

        request.then((response) => {
          dispatch(api.handleResponse(events.submitted.adviser, response))
        })
      }
    }
  }
}